var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _circle2, _path0, _linearGradient, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.64 41.1L38.95 13.88c-.3-.38-.25-.93.11-1.25c.38-.33.95-.3 1.28.08L63.41 38.7c.33.38.3.95-.08 1.28l-1.38 1.22c-.39.35-.99.3-1.31-.1z",
    fill: "#455a64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.21 40.95l-1.24-1.1c-.41-.37-.45-1-.08-1.41l22.94-25.86c.37-.41 1-.45 1.41-.08c.4.35.45.96.12 1.38l-21.7 26.96c-.37.43-1.03.49-1.45.11z",
    fill: "#455a64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.74 42.46c0-3.49 7.74-6.33 17.29-6.33s17.29 2.83 17.29 6.33H47.74z",
    fill: "#455a64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.57 124H8.43C5.98 124 4 121.94 4 119.41V45.1c0-2.54 1.98-4.59 4.43-4.59h111.15c2.44 0 4.43 2.06 4.43 4.59v74.31c-.01 2.53-1.99 4.59-4.44 4.59z",
    fill: "#82aec0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.35 119.64H11.97a3.55 3.55 0 0 1-3.55-3.55V48.04a3.55 3.55 0 0 1 3.55-3.55h104.38a3.55 3.55 0 0 1 3.55 3.55v68.05a3.55 3.55 0 0 1-3.55 3.55z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.39 108.96l-4.8 7.55c-.84 1.32.06 3.11 1.62 3.12h82.85c1.77-.01 2.92-1.87 2.15-3.46l-3-6.18l-78.82-1.03z",
    fill: "#b9e4ea"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.45 105.47c-.77 3.47-3.34 6.15-6.64 6.88c-5.42 1.21-15.52 2.72-32.16 2.72c-17.47 0-29.19-1.66-35.5-2.89c-3.49-.68-6.23-3.54-6.91-7.23c-1.57-8.48-3.54-25.43.08-46.6c.67-3.92 3.66-6.93 7.39-7.44c6.73-.93 18.75-2.17 34.94-2.17c15.36 0 25.65 1.12 31.48 2.02c3.59.56 6.46 3.47 7.19 7.24c4.33 22.3 1.94 39.29.13 47.47z",
    fill: "#2f7889",
    stroke: "#212121",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.89 116.47H103.5a2.09 2.09 0 0 1-2.09-2.09V90.63c0-1.16.94-2.09 2.09-2.09h11.39c1.16 0 2.09.94 2.09 2.09v23.75c0 1.15-.93 2.09-2.09 2.09z",
    fill: "#455a64"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.2,
    cy: 58.31,
    r: 6.89,
    fill: "#455a64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.2 51.98c-.53 0-.99.36-1.11.87l-.9 3.7a7.438 7.438 0 0 0 0 3.51l.9 3.7c.13.51.58.87 1.11.87c.53 0 .99-.36 1.11-.87l.9-3.7c.28-1.15.28-2.35 0-3.51l-.9-3.7c-.13-.51-.59-.87-1.11-.87z",
    fill: "#82aec0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.2,
    cy: 76.12,
    r: 6.89,
    fill: "#455a64"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M104.33 72.08c-.34.41-.35.99-.04 1.41l2.27 3.05a7.42 7.42 0 0 0 2.7 2.24l3.42 1.66c.47.23 1.04.11 1.38-.3c.34-.41.35-.99.04-1.41l-2.27-3.05a7.42 7.42 0 0 0-2.7-2.24l-3.42-1.66c-.47-.23-1.04-.1-1.38.3z",
    fill: "#82aec0"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab21128",
    gradientUnits: "userSpaceOnUse",
    x1: 29.355,
    y1: 35.146,
    x2: 28.31,
    y2: 73.055
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.08 55.78c1.68-.2 4.86-.06 5.98 3.35s-1.34 4.33-2.66 5.34c-3.79 2.89-5.67 3.99-7.95 7.14c-1.82 2.52-5 1.73-5.95.07c-.76-1.34-1.32-5.64.29-8.48c3.47-6.08 8.61-7.22 10.29-7.42z",
    fill: "url(#IconifyId17ecdb2904d178eab21128)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.af86e0eb18539b3eed9640aeb68a3b28.svg";
export { ForwardRef as ReactComponent };